var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SettlementDeliveryCard',_vm._b({attrs:{"status":"","status-color":"warning","order-id":_vm.settlement.orderId,"is-mobile":_vm.$q.screen.xs}},'SettlementDeliveryCard',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }